import React, { useState, useEffect } from "react";

const UploadALL = ({
  selectedFile,
  setSelectedFile,
  image, // existing file (string URL)
  className,
  label,
  setImageForPackages,
  mandatory,
  placeholder,
  width,
  accept,
  height,
  maxSize,
}) => {
  const [remove, setRemove] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  // Create preview URL safely
  useEffect(() => {
    if (selectedFile && typeof selectedFile !== "string") {
      const url = URL.createObjectURL(selectedFile);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url); // cleanup
    } else if (typeof selectedFile === "string") {
      setPreviewUrl(selectedFile);
    } else if (image && !remove) {
      setPreviewUrl(image); // fallback to existing file
    } else {
      setPreviewUrl(null);
    }
  }, [selectedFile, image, remove]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file || null);
  };

  const handleRemoveFile = () => {
    setRemove(true);
    if (setImageForPackages) setImageForPackages(null);
    setSelectedFile(null);
  };
const getFileType = (file, previewUrl) => {
  if (file && file.type) return file.type.toLowerCase();

  // fallback to extension check from URL
  if (previewUrl) {
    const ext = previewUrl.split(".").pop()?.toLowerCase();
    if (ext) {
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
      if (["mp4", "webm", "mov", "avi"].includes(ext)) return "video";
      if (["mp3", "wav", "ogg"].includes(ext)) return "audio";
      if (["pdf"].includes(ext)) return "pdf";
      if (["doc", "docx"].includes(ext)) return "doc";
      if (["xls", "xlsx"].includes(ext)) return "xls";
    }
  }

  return "unknown";
};
 const renderPreview = () => {
  if (!previewUrl) return null;

  const fileType = getFileType(selectedFile, previewUrl);
  const fileName =
    (selectedFile && selectedFile.name) ||
    (typeof previewUrl === "string" && previewUrl.split("/").pop()) ||
    "File";

  switch (fileType) {
    case "pdf":
      return <iframe src={previewUrl} style={{ width: "100%" }} />;
    case "audio":
      return <audio src={previewUrl} controls style={{ width: "100%" }} />;
    case "image":
      return (
        <img
          src={previewUrl}
          alt="preview"
          style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }}
        />
      );
    case "video":
      return (
        <video
          src={previewUrl}
          controls
          style={{ width: "100%", maxHeight: "300px" }}
        />
      );
    case "doc":
      return <div>📄 Word Document: {fileName}</div>;
    case "xls":
      return <div>📊 Excel File: {fileName}</div>;
    default:
      return <div style={{ fontWeight: "bold" }}>📁 {fileName}</div>;
  }
};

  return (
    <div className={className || "col-12"}>
      <div className="fieldrow">
        <label className="f_label">
          {label} <span style={{ color: "red" }}>{mandatory}</span>
        </label>
        <div className="upload_box">
          <input
            type="file"
            onChange={handleFileChange}
            accept={accept || "*/*"}
          />
          <i className="ri-upload-cloud-2-line"></i>
          <span>{placeholder}</span>
          {width && height && (
            <span>{`Height: ${height}, Width: ${width}`}</span>
          )}
          {maxSize && (
            <span style={{ color: "#666", fontSize: "12px" }}>Max size: {maxSize}</span>
          )}
        </div>
      </div>

      <div className="fieldrow uploaded_item">
        <ul>
          {(selectedFile || (image && !remove)) && (
            <li>
              {renderPreview()}
              <button onClick={handleRemoveFile} type="button">
                <i className="ri-close-line"></i>
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default UploadALL;
